var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePreviewArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26284 11.7016H11.1903V2.3941C11.1903 1.18522 12.1693 0.204102 13.3803 0.204102C14.5914 0.204102 15.5703 1.18522 15.5703 2.3941V11.7016H20.4978C21.963 11.7016 22.6922 13.4755 21.6585 14.5048L14.541 21.6223C14.2213 21.9442 13.8008 22.1041 13.3803 22.1041C12.9599 22.1041 12.5394 21.9442 12.2196 21.6223L5.10215 14.5048C4.06847 13.4755 4.79773 11.7016 6.26284 11.7016Z",
    fill: "#394154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3302 30.8644H2.43023C1.21916 30.8644 0.240234 29.8833 0.240234 28.6744C0.240234 27.4655 1.21916 26.4844 2.43023 26.4844H24.3302C25.5413 26.4844 26.5202 27.4655 26.5202 28.6744C26.5202 29.8833 25.5413 30.8644 24.3302 30.8644Z",
    fill: "#394154"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePreviewArrow);
export default __webpack_public_path__ + "static/media/file-preview-arrow.0cf80316cb4421b7984ac20596501b2e.svg";
export { ForwardRef as ReactComponent };